import { useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "../Redux/store";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector = () => useSelector((state: RootState) => state);
